import React, { Component } from 'react'
import SelectedPlanCard from '../components/SelectedPlanCard'
import { Button } from 'react-bootstrap'
import ComparePlansModal from '../../../ui/plans/ComparePlansModal'
import { Field } from 'formik'

class SelectPlanForm extends Component {
    constructor(props) {
        super(props)
        console.log(props);
        
        this.state = {
            showPlansModal: false,
            plan: props.initialValues?.plan
        }
    }

    render() {
        return (
            <div className="select-plan-form">
                {this.renderBody()}
                {this.renderModals()}
            </div>
        )
    }

    /**
     * Renders
     */

    renderBody() {
        const { plan } = this.state;
        
        return (
            <div className="select-plan-form--body">
                <SelectedPlanCard plan={plan} />
                <Field name="plan" value={plan} hidden />
                <Button variant="link" className="px-0" className="sm" onClick={() => this.setShowPlansModal(true)}>Change/View Plan</Button>
            </div>
        )
    }

    renderModals() {
        return (
            <ComparePlansModal
                show={this.state.showPlansModal}
                onHide={() => this.setShowPlansModal(false)}
                onSelect={this.handlePlanSelect}
            />
        )
    }

    /**
     * Handlers
     */

    setShowPlansModal = show => {
        this.setState({ showPlansModal: show })
    }

    handlePlanSelect = plan => {
        this.setState({ plan });
        this.setShowPlansModal(false)
    }
}

export default SelectPlanForm